import React from 'react';
import { TELECARE_PHONE, TELECARE_PHONE_HREF } from '../../constants/contact';
import '../../pages/BookingHome/uplift.css';

// Shown by the app's error boundary; styled like the booking site.
const Error = () => (
  <div className="bk">
    <header className="brandbar" style={{ display: 'block' }}>
      <div className="in">
        <img src="/telecare-logo.svg" alt="Telecare" />
      </div>
    </header>
    <div className="app">
      <div className="cols solo" style={{ marginTop: 24 }}>
        <section className="panel" role="alert">
          <h2>Sorry, something went wrong</h2>
          <p className="psub">
            {'Please refresh the page and try again. If it keeps happening, call Telecare on '}
            <a href={TELECARE_PHONE_HREF}>{TELECARE_PHONE}</a>
            .
          </p>
          <button type="button" className="btn btn-p" onClick={() => window.location.reload()}>Refresh the page</button>
        </section>
      </div>
    </div>
  </div>
);

export default Error;
